import React, { useState, useEffect } from "react";

export default function DisplayLiveStreamDetails(props) {
  const id = window.location.href.split("/display-stream-details/")[1];
  const [loading, setLoading] = useState(true);
  const [stream, setStream] = useState(null);

  async function getStream() {
    // TODO add Livepeer AWS switching logic for get stream details
    console.log(id);
    let fetchedStream;
    if(true) {
      fetchedStream = await fetch(
        `https://73vw7wmlk1.execute-api.us-west-2.amazonaws.com/dev/get_aws_channel_from_id`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: id }),
        }
      ).then((res) => res.json());
      console.log(fetchedStream);
    } else {
      fetchedStream = await fetch(
        `https://73vw7wmlk1.execute-api.us-west-2.amazonaws.com/dev/getStreamFromId`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: id }),
        }
      ).then((res) => res.json());
    }
    setStream(fetchedStream);
    setLoading(false);
  }

  useEffect(() => {
    getStream();
  }, []);

  if (loading || stream === null) {
    return <div>Loading...</div>;
  }

  console.log(stream);

  return (
    <div className="mx-auto w-full min-h-screen flex flex-col items-center justify-center border-white-600 dark:border-zinc-800 border-x-2">
      <div className="mt-10 dark:bg-zinc-900 bg-gray-200 w-7/12 h-48 flex flex-col justify-around rounded-lg dark:border-zinc-800 shadow-md dark:border-2">
        <div className="font-semibold ml-4 dark:text-white text-black text-xl font-semibold">
          Livestream Information
        </div>
        <div className="ml-4 dark:text-gray-200 text-gray-700 font-semibold text-sm">
          Server: rtmps://670df84c3349.global-contribute.live-video.net:443/app/
        </div>
        <div className="ml-4 dark:text-gray-200 text-gray-700 font-semibold text-sm">
          Stream Key: {stream.streamKey}
        </div>
        {
          stream.playbackId != null
            ?
          <div className="ml-4 dark:text-gray-200 text-gray-700 font-medium text-sm">
            Playback ID:{stream.playbackId}
          </div>
            :
          null
        }
      </div>
      {
        stream.playbackId != null
          ?
        <iframe className="w-96 h-64 mt-10"
          src={`https://lvpr.tv?v=${stream.playbackId}`}
          frameborder="0"
          allowfullscreen
          allow="autoplay; encrypted-media; picture-in-picture"
          sandbox="allow-scripts"
        >
        </iframe>
          :
        null
      }
      <div className="ml-4 w-7/12 mt-10">
      <div className="text-black dark:text-white font-semibold text-2xl">
        Instructions
      </div>
      <div>
        <div className="dark:text-gray-900 text-gray-700 mt-4">
          <a className="text-blue-400" href="https://obsproject.com/download">Download and Install OBS</a>
        </div>
        <div className="italic dark:text-gray-400 text-gray-700 text-sm">
          OBS is free and open source software for live streaming
        </div>
        <div className="mt-4 dark:text-gray-200 text-gray-700">
          Click on settings on the lower right corner
        </div>
        <div className="mt-4 dark:text-gray-200 text-gray-700">
          In the Settings sidebar menu, select Output
        </div>
          <div className="mt-4 dark:text-gray-200 text-gray-700">
            At the top, select Advanced from the Output Mode dropdown
          </div>
          <div className="mt-4 dark:text-gray-200 text-gray-700">
            In the Keyframe Interval row, input 2 in the text field
          </div>
          <div className="mt-4 dark:text-gray-200 text-gray-700">
            In the Settings sidebar menu, select Stream
          </div>
          <div className="mt-4 dark:text-gray-200 text-gray-700">
            At the top, select Custom from the Service dropdown menu
          </div>
          <div className="mt-4 dark:text-gray-200 text-gray-700">
            Input rtmps://670df84c3349.global-contribute.live-video.net:443/app/ in the Server text field
          </div>
          <div className="mt-4 dark:text-gray-200 text-gray-700">
            Paste your stream key into the Stream Key text field
          </div>
          <div className="mt-4 dark:text-gray-200 text-gray-700">
            Confirm the Use Authentication checkbox is unchecked
          </div>
          <div className="mt-4 dark:text-gray-200 text-gray-700">
            Click OK in the lower right corner to save your updated server and
            keyframe interval settings
          </div>
          <div className="mt-4 dark:text-gray-200 text-gray-700">
            When you are ready to start your live stream, click Start Streaming in
            the lower right corner of OBS
          </div>
          <div className="mt-4 dark:text-gray-200 text-gray-700 mb-10">
            Now your Livestream should be playing on your profile page!
          </div>
      </div>
      </div>
    </div>
  );
}
